<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Examination</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <div>
              <h2>Section {{ courseSection }}</h2>
            </div>
          </CRow>
          <CRow alignHorizontal="end" class="row-header">
            <div>
              <template v-if="quizSelected.length > 0">
                <div class="button button-icon button-blue" @click="setIsScheduleExamModalShow()">
                  Config Selected ({{ quizSelected.length }})
                </div>
              </template>
            </div>
          </CRow>
          <CRow>
            <CCol col="12">
              <CDataTable :items="data" :fields="fields" hover striped>
                <template #topic="{ item }">
                  <td>
                    <div style="text-align: left">{{ item.topic }}</div>
                  </td>
                </template>
                <template #test="{ item }">
                  <td>
                    <div style="text-align: left">{{ item.test }}</div>
                  </td>
                </template>
                <template #status="{ item }">
                  <td class="d-flex flex-row align-items-center">
                    <div class="icon-circle" :style="getStatusColor(item.status)" />
                    <div v-if="!item.status" style="color: green">ON</div>
                    <div v-else style="color: grey">OFF</div>
                  </td>
                </template>
                <template #action="{ item }">
                  <td class="iconColor">
                    <div v-if="courseSelected.length <= 0">
                      <!-- <c-icon name="cilSettings" class="icon-setting" /> -->
                      <CButton @click="setIsConfirmModalShow(item, item.status)" variant="outline"
                        :color="checkOnOffColor(item.status)" class="m-2">
                        {{ checkOnOffText(item.status) }}
                      </CButton>
                    </div>
                  </td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
    <ModalConfirm :modalVisible="isConfirmModalShow" :setModalVisible="setIsConfirmModalShow"
      :dataObject="courseTopicSelected" :courseSection="courseSection" :status="!quizStatus"
      @returnChangeQuizStatus="returnChangeQuizStatus" />
  </CContainer>
</template>

<script>
import ModalConfirm from "../../modal/ModalChangeStatus";
import ModalScheduleExam from "../../modal/ScheduleExam";

const fields = [
  { key: "topic", label: "TOPIC" },
  { key: "status", label: "STATUS" },
  { key: "action", label: "ACTION", filter: false },
];

export default {
  name: "examination",
  props: {
    testData: Array,
    courseSection: String,
    courseName: String,
    courseId: String,
    courseDetailData: Object,
  },
  components: {
    ModalConfirm,
    ModalScheduleExam,
  },
  created() {
    this.section = this.courseSection;
  },
  data() {
    return {
      isScheduleExamModalShow: false,
      isConfirmModalShow: false,
      items: [],
      fields,
      courseSelected: [],
      courseTopicSelected: null,
      quizSelected: [],
      data: [],
      isCheck: false,
      quizStatus: false,
      section: "",
    };
  },
  watch: {
    courseSection(value) {
      this.section = value;
    },
    testData: {
      handler(value) {
        if (value) {
          this.setDataForTable(value);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setDataForTable(value) {
      this.data = [];
      if (value.length > 0) {
        // value.forEach((element) => {
        //   let obj = {
        //     contentId: element.contentId,
        //     topic:
        //       element.description[0].val == "Pretest"
        //         ? "Pre Test"
        //         : element.description[0].val == "Posttest"
        //         ? "Post Test"
        //         : element.description[0].val,
        //     status: element.lock,
        //     section: this.courseSection,
        //   };
        //   this.data.push(obj);
        // });
        console.log('sssssssssssssssss', value);

        for (let i = 0; i < value.length; i++) {
          const element = value[i];
          let dummyChapter = null

          if (element.type == "pretest" || element.type == "posttest") {
              if (element.type == "pretest") {
                dummyChapter = "Pre Test"
              }
              if (element.type == "posttest") {
                dummyChapter = "Post Test"
              }
          } else {
            dummyChapter = element.type + i
            // element.type = element.type + i
          }

          const obj = {
            contentId: element._id,
            topic: dummyChapter,
            status: element.isLock,
            section: this.courseSection,
            type: element.type,
            codeItem: element.codeItem
          };
          this.data.push(obj);

        }// loop

        // value.forEach((element) => {
        //   let obj = {
        //     contentId: element._id,
        //     topic: element.type == "pretest" ? "Pre Test" : element.type == "posttest" ? "Post Test" : element.type,
        //     status: element.isLock,
        //     section: this.courseSection,
        //     type: element.type,
        //     codeItem: element.codeItem
        //   };
        //   this.data.push(obj);
        // });
      }
    },
    getStatusColor(status) {
      if (!status) {
        return "background-color: #0BB190 !important";
      } else {
        return "background-color: lightgrey !important";
      }
    },
    setCourseSelected(selected) {
      var chk = document.getElementById(selected.num).checked;
      if (chk) {
        this.quizSelected.push({
          idQuiz: selected.num,
          name: selected.topic,
          status: !selected.status,
        });
      } else {
        for (let i = 0; i < this.quizSelected.length; i++) {
          if (this.quizSelected[i].idQuiz == selected.num) {
            this.quizSelected.splice(i, 1);
          }
        }
      }
    },
    setIsScheduleExamModalShow(status) {
      this.isScheduleExamModalShow = !this.isScheduleExamModalShow;
    },
    setIsConfirmModalShow(item, status) {

      if (status == false) {
        if (item.topic == 'Pre Test') {
          return alert('You cannot lock Pre Test')
        }
      }
      this.isConfirmModalShow = !this.isConfirmModalShow;
      this.courseTopicSelected = item;
      this.quizStatus = status;
    },
    returnChangeQuizStatus(data) {
      let courseDetailTmp = this.$store.getters["courses/getCourseObjectParams"];
      if (data) {
        // let dataTmp = {
        //   courseId: courseDetailTmp.courseId,
        //   section: this.section,
        //   data: [
        //     {
        //       contentID: data.contentId,
        //       lock: !data.status,
        //     },
        //   ],
        //   academicYear: this.courseDetailData.academicYear.toString() ,
        //   semester : this.courseDetailData.semester.toString()
        // };

        const dataTmp = [{
          courseinfo: courseDetailTmp.courseId,
          codeItem: data.codeItem,
          type: data.type,
          section: this.section,
          isLock: !data.status
        }]
        console.log('Click mother fucker', data);
        
        this.$emit("returnUpdateQuiz", dataTmp);
        this.isConfirmModalShow = !this.isConfirmModalShow;
      }
    },
    checkOnOffColor(val) {
      if (val == false) {
        return "warning";
      } else {
        return "success";
      }
    },
    checkOnOffText(val) {
      if (val == false) {
        return "Turn Off";
      } else {
        return "Turn On";
      }
    },
  },
};
</script>
<style>
.table td {
  font-size: 16px !important;
}

.icon-circle {
  width: 20px;
  height: 20px;
  padding: 2px 5px;
  background-color: lightgrey;
  border-radius: 50%;
  margin: 0 10px;
}

.icon-setting:hover {
  cursor: pointer;
  color: brown;
}
</style>
